import { memoryRepository } from '../repositories/memory-repository';

async function openMemoryChat(chapter) {
    return memoryRepository.openChat(chapter);
}

export {
    openMemoryChat
};
